import { BLOCKS, CommonNode } from "@foundation/rich-text-react-renderer";
import { Block, Text } from "@foundation/rich-text-react-renderer/lib/@types";

import { MEDIA_SUBTYPES } from "~types/types";

const CHARACTERS_PER_CONTENT_BLOCK = 250;

export const getCharCount = (textContent: Array<Block | Text>) => {
    const retCount = textContent.reduce(
        (previousValue: number, item: Block | Text) => {
            let count = 0;

            if (item.type === "text") {
                count += (item as Text).value.length;
            } else if (item.type === "link") {
                count += getCharCount(item.content);
            }

            return previousValue + count;
        },
        0
    );

    return retCount;
};

export const blockCalculation = (paragraph: CommonNode) => {
    const count = getCharCount(paragraph.content as Text[]);
    const blocks = count / CHARACTERS_PER_CONTENT_BLOCK;

    return blocks;
};

export const basicArticleContentBlockLength = (
    content: CommonNode[] | undefined
) => {
    if (!content) {
        return 0;
    }

    const contentLength: number = content.reduce(
        (preValue, item) =>
            item.type === BLOCKS.PARAGRAPH
                ? preValue + blockCalculation(item)
                : preValue + 1,
        0
    );

    return contentLength;
};

export const getNumberOfParagraphs = (content: CommonNode[]) =>
    content.filter((node) => node.type === "paragraph").length;

export const hasInlineAudioPlayer = (content: CommonNode[]) => {
    function search(nodes: CommonNode[]): boolean {
        return nodes.some((node) => {
            if (
                node.type === BLOCKS.MEDIA &&
                node.subType === MEDIA_SUBTYPES.AUDIO &&
                node.data.attachment?.title &&
                node.data.attachment?.url
            ) {
                return true;
            }

            if (node.type === BLOCKS.DIV && Array.isArray(node.content)) {
                return search(node.content);
            }

            return false;
        });
    }

    return search(content);
};
